import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import ContentHeader from '../../common/ContentHeader/ContentHeader';
import Divider from '../../common/divider/Divider';

const HazardousModal = (props: any) => {
    const {
        setAddScreen,
        clearModal,
        resetFocusToUpc,
        modalType,
        reasonCodeList,
        showReasonCode,
    } = props;
    const [subDispositions, setSubDispositions] = useState('');
    const [reasonCode, setReasonCode] = useState('');

    const [errors, setErrors] = useState({
        subDispositionError: '',
        reasonCodeError: '',
    });

    const getSubDispositions = useSelector(
        (state: RootState) => state.scanReducer.subDispositionsByState
    );

    let subDispositionError = '';
    const handleCancel = () => {
        setAddScreen(false);
        resetFocusToUpc();
        clearModal();
    };

    const handleSubDispositions = () => {
        if (props.isFrom === 'frocetrashmain') {
            props.handleForceToTrash(subDispositions);
            setAddScreen(false);
            resetFocusToUpc();
            clearModal();
        } else {
            if (validate()) {
                props.handleHazardous({ subDispositions, reasonCode });
                setAddScreen(false);
                resetFocusToUpc();
                clearModal();
            }
        }
    };
    const validate = () => {
        let errorMessages: any = {};
        let isValid = true;

        if (subDispositions === '') {
            errorMessages.subDispositionError = 'Sub-disposition is required';
            isValid = false;
        }

        if (reasonCode === '' && showReasonCode === true) {
            errorMessages.reasonCodeError = 'Reason Code is required';
            isValid = false;
        }

        setErrors({ ...errors, ...errorMessages });

        return isValid;
    };
    return (
        <>
            <ContentHeader value="Hazardous Force to Trash" />
            <Divider />
            <div className="col-sm-12">
                <div className="text-center p5 fb-15">
                    {showReasonCode
                        ? 'Please select sub-disposition and reason code for hazardous force to trash item'
                        : 'Please select sub-disposition for hazardous force to trash item'}
                </div>
            </div>
            <div className="col-sm-4 p5"></div>
            <div className="col-sm-4 p5">
                {showReasonCode && (
                    <label>Sub-disposition</label>
                )}
                <select
                    className="form-control"
                    onChange={(e) => setSubDispositions(e.target.value)}
                >
                    <option value="">Select</option>
                    {getSubDispositions.payload?.map((sd: any) => (
                        <option value={sd.code}>
                            {' '}
                            {sd.code + '(' + sd.description + ')'}
                        </option>
                    ))}
                </select>
                {subDispositions === '' ? (
                    <span className="text-danger">
                        {errors.subDispositionError}
                    </span>
                ) : (
                    ''
                )}

                {showReasonCode && (
                    <div className="py-5">
                        <label>Reason Code</label>
                        <select
                            className="form-control"
                            onChange={(e) => setReasonCode(e.target.value)}
                        >
                            <option value="">Select</option>
                            {reasonCodeList?.map((sd: any) => (
                                <option value={sd.reasonCode}>
                                    {sd.reasonCode}
                                </option>
                            ))}
                        </select>

                        {reasonCode === '' ? (
                            <span className="text-danger">
                                {errors.reasonCodeError}
                            </span>
                        ) : (
                            ''
                        )}
                    </div>
                )}
            </div>
            <div className="col-sm-4 p5"></div>
            <div className="col-sm-9 mt-2rem">
                <ButtonComponent
                    cssClass="eg-btn-primary float-right btnBox"
                    onClick={() => handleSubDispositions()}
                >
                    Ok
                </ButtonComponent>
                <ButtonComponent
                    cssClass="eg-btn-secondary float-right mr-4"
                    onClick={() => handleCancel()}
                >
                    Cancel
                </ButtonComponent>
            </div>
        </>
    );
};

export default HazardousModal;
